/**
 * @voltxampere/spice
 *
 * Berkeley SPICE3 netlist parser + emitter for VoltXAmpere v3.
 *
 * Public API surface (Sprint 16):
 *   - `parse(source)`         — text → NetlistDoc
 *   - `fromSpice(doc)`        — NetlistDoc → Circuit
 *   - `toSpice(circuit)`      — Circuit → text
 *   - `parseSpice(source)`    — convenience: text → Circuit
 *   - `parseSpiceNumber`,     — value-with-suffix helpers
 *     `formatSpiceValue`
 *   - `SpiceParseError`,      — error types with line/col tracking
 *     `CodecError`
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { parse } from "./parser.js";
import { fromSpice } from "./transforms/from-spice.js";
export const PACKAGE_NAME = "@voltxampere/spice";
export const PACKAGE_VERSION = "0.1.0";
export { parse } from "./parser.js";
export { fromSpice } from "./transforms/from-spice.js";
export { toSpice } from "./transforms/to-spice.js";
// Sprint 49 ADR-0071 — KiCad eCircuit `.net` adapter.
export { parseSExpression, parseKiCadNet, mapKiCadLibsourceToVariant, KiCadParseError, } from "./transforms/from-kicad.js";
// Sprint 49 ADR-0071 — HSPICE compat shim (preprocessor).
export { preprocessHSpice, isHSpiceDialect } from "./parsers/hspice-shim.js";
export { netToSpiceName, resolveNet, createResolverContext, listNets, } from "./transforms/net-resolver.js";
export { SpiceParseError, CodecError, makeIssue } from "./errors.js";
export { parseSpiceNumber, formatSpiceValue } from "./units.js";
export { snapPoint, snapToGrid, SPICE_GRID_PITCH } from "./grid-snap.js";
export { parseACDirective, emitACDirective } from "./directives/ac-directive.js";
export { ALL_CODECS, findCodecsByLetter, findCodecBySchemaType } from "./element-codecs/index.js";
export function parseSpice(source, opts) {
    const outcome = parse(source);
    if (!outcome.ok) {
        return {
            circuit: null,
            warnings: [],
            errors: outcome.issues.map((i) => ({
                line: i.line,
                col: i.col,
                message: i.message,
            })),
        };
    }
    const transform = fromSpice(outcome.doc, opts);
    return {
        circuit: transform.circuit,
        warnings: [
            ...outcome.warnings.map((w) => `Line ${String(w.line)}: ${w.message}`),
            ...transform.warnings,
        ],
        errors: [],
    };
}
//# sourceMappingURL=index.js.map